module.exports = __webpack_public_path__ + "static/media/account-setup.264a3bbe.md";